module.exports = __webpack_public_path__ + "static/media/gradient-startY-icon.77d5238c.svg";